/* MS Belts 3.0, product page behaviour. Loaded with defer by sections/main-product.liquid.
   Custom elements:
     <product-gallery>  photo stage (scroll-snap), previous/next, "3 / 9" counter, thumbnails, and a
                        full-screen lightbox <dialog> with click-to-zoom, swipe and keyboard support
     <product-build>    upgrades (add-on products), name plate engraving, legacy variant pills, the live
                        "Your build" total, add to cart and the sticky add-to-cart bar
   Also: product recommendations, fetched as rendered section HTML.
   The page works without this file: the stage scrolls, thumbnails jump to their photo, photos open at
   full size, legacy options reload the page and the product form posts natively (the belt alone).
   Add to cart follows spec/design-v3.md section 3: one POST to {routes.root}cart/add.js with
   items [add-ons..., belt], all sharing a hidden _ms_group id. No innerHTML anywhere; analytics go
   through window.MSTrack.event and the cart through window.MS, both guarded. */
(function () {
  'use strict';

  if (window.MSProduct || !window.customElements) return;
  window.MSProduct = { ready: true };

  var doc = document;
  var TEXT = {
    selected: 'Selected',
    samePrice: 'Same price',
    notOffered: 'Not offered',
    notAvailable: 'Not available',
    adding: 'Adding…',
    added: 'Added to your cart.',
    standardBuild: 'Standard build',
    total: 'Total',
    engraving: 'Name plate engraving',
    quantity: 'Quantity',
    engraveMissing: 'Type the name to engrave, or untick the engraving option.',
    addFailed: 'This could not be added to your cart. Please try again.',
    offline: 'This could not be added to your cart. Please check your connection and try again.'
  };

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function track(name, params) {
    try {
      if (window.MSTrack && typeof window.MSTrack.event === 'function') window.MSTrack.event(name, params || {});
    } catch (error) {
      /* Tracking must never break the page. */
    }
  }

  function readJSON(element) {
    try {
      return element ? JSON.parse(element.textContent) : null;
    } catch (error) {
      return null;
    }
  }

  var config = readJSON(doc.getElementById('ms-config')) || {};

  function rootUrl() {
    var root = String((config.routes && config.routes.root) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cartUrl() {
    return (config.routes && config.routes.cart) || rootUrl() + 'cart';
  }

  /* The shop money format may carry markup and entities ("<span class=money>${{amount}}</span>"). */
  function plainFormat(format) {
    var text = String(format || '');
    try {
      text = new DOMParser().parseFromString(text, 'text/html').documentElement.textContent || text;
    } catch (error) {
      /* Keep the raw format. */
    }
    return text;
  }

  /* Formats cents with the shop money format, for example "${{amount}}". */
  function formatMoney(cents, format) {
    function number(decimals, thousands, decimal) {
      var parts = (Math.abs(cents) / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    if (!pattern.test(format)) format = '${{amount}}';
    return format.replace(pattern, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return number(0, ',', '.');
        case 'amount_with_comma_separator': return number(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return number(0, '.', ',');
        case 'amount_with_apostrophe_separator': return number(2, '\'', '.');
        case 'amount_no_decimals_with_space_separator': return number(0, ' ', ',');
        case 'amount_with_space_separator': return number(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return number(2, ' ', '.');
        default: return number(2, ',', '.');
      }
    });
  }

  function capitalise(text) {
    text = String(text || '');
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function clearChildren(element) {
    while (element.firstChild) element.removeChild(element.firstChild);
  }

  function groupId() {
    return Date.now().toString(36).slice(-5) + Math.random().toString(36).slice(2, 7);
  }

  function scrollToLeft(element, left) {
    try {
      element.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    } catch (error) {
      element.scrollLeft = left;
    }
  }

  /* =====================================================================================
     <product-gallery>
     ===================================================================================== */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-pg-track]');
      if (!this.track) return;
      this.productId = Number(this.getAttribute('data-product-id')) || null;
      this.slides = all(this.track, '[data-pg-slide]');
      this.thumbs = all(this, '[data-pg-thumb]');
      this.index = 0;
      this.quietUntil = 0;
      this.target = null;
      this.lightbox = null;
      this.initStage();
      this.initLightbox();
    }

    initStage() {
      var self = this;
      var many = this.slides.length > 1;
      this.counterValue = this.querySelector('[data-pg-current]');
      ['[data-pg-prev]', '[data-pg-next]', '[data-pg-count]'].forEach(function (selector) {
        var element = self.querySelector(selector);
        if (element && many) element.hidden = false;
      });

      var prev = this.querySelector('[data-pg-prev]');
      var next = this.querySelector('[data-pg-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, 'prev'); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1, 'next'); });

      /* Thumbnails are links to their slide (no-JS fallback); with JS they move the stage in place. */
      this.thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          self.go(index, 'thumbnail');
        });
      });

      var pending = false;
      this.track.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          self.sync();
        });
      }, { passive: true });

      this.track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target && event.target.closest && event.target.closest('video, iframe')) return;
        event.preventDefault();
        var forward = event.key === 'ArrowRight';
        self.go(self.index + (forward ? 1 : -1), forward ? 'next' : 'prev', true);
      });

      this.track.addEventListener('click', function (event) {
        var link = event.target && event.target.closest ? event.target.closest('[data-pg-open]') : null;
        if (!link || !self.lightbox) return;
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        self.openLightbox(link);
      });

      this.mark(0);
    }

    /* Marks slide `index` as current: thumbnail, counter, tab stop; pauses videos elsewhere. */
    mark(index) {
      this.index = index;
      this.thumbs.forEach(function (thumb, position) {
        if (position === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.slides.forEach(function (slide, position) {
        var link = slide.querySelector('[data-pg-open]');
        if (link) link.tabIndex = position === index ? 0 : -1;
        if (position !== index) {
          all(slide, 'video').forEach(function (video) {
            if (!video.paused) video.pause();
          });
        }
      });
      if (this.counterValue) this.counterValue.textContent = String(index + 1);

      var thumb = this.thumbs[index];
      var strip = thumb ? thumb.closest('[data-pg-thumbs]') : null;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var item = thumb.parentNode;
        scrollToLeft(strip, Math.max(0, item.offsetLeft - (strip.clientWidth - item.offsetWidth) / 2));
      }
    }

    /* Keeps the counter and thumbnails in step with swipes and scrolling. */
    sync() {
      var width = this.track.clientWidth;
      if (!width) return;
      var index = Math.round(this.track.scrollLeft / width);
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      /* While a button or thumbnail scrolls the stage, ignore the slides it passes on the way. */
      if (Date.now() < this.quietUntil && this.target !== null && index !== this.target) return;
      if (index === this.index) return;
      this.mark(index);
      if (Date.now() > this.quietUntil) {
        this.quietUntil = Date.now() + 700;
        track('gallery_interaction', { product_id: this.productId, action: 'swipe', index: index + 1 });
      }
    }

    go(index, action, focus) {
      var count = this.slides.length;
      if (!count) return;
      index = (index % count + count) % count;
      this.quietUntil = Date.now() + 1000;
      this.target = index;
      scrollToLeft(this.track, this.slides[index].offsetLeft);
      this.mark(index);
      if (focus) {
        var link = this.slides[index].querySelector('[data-pg-open]');
        if (link) link.focus({ preventScroll: true });
      }
      if (action) track('gallery_interaction', { product_id: this.productId, action: action, index: index + 1 });
    }

    /* Used by listings with options: a variant with its own photo brings that photo forward. */
    showMedia(mediaId) {
      for (var i = 0; i < this.slides.length; i += 1) {
        if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) {
          if (i !== this.index) this.go(i, null);
          return;
        }
      }
    }

    /* ---------- Lightbox: native modal dialog (focus containment, Escape, inert page) ---------- */
    initLightbox() {
      var dialog = this.querySelector('[data-pg-lightbox]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var self = this;
      this.lightbox = dialog;
      this.lbStage = dialog.querySelector('[data-pg-lb-stage]');
      this.lbImg = dialog.querySelector('[data-pg-lb-img]');
      this.lbCount = dialog.querySelector('[data-pg-lb-count]');
      this.lbZoom = dialog.querySelector('[data-pg-lb-zoom]');
      this.lbClose = dialog.querySelector('[data-pg-lb-close]');
      this.lbLinks = all(this.track, '[data-pg-open]');
      this.lbIndex = 0;
      this.zoomed = false;
      this.opener = null;
      if (!this.lbStage || !this.lbImg || !this.lbClose || !this.lbLinks.length) {
        this.lightbox = null;
        return;
      }

      var prev = dialog.querySelector('[data-pg-lb-prev]');
      var next = dialog.querySelector('[data-pg-lb-next]');
      if (prev) prev.addEventListener('click', function () { self.lbGo(self.lbIndex - 1); });
      if (next) next.addEventListener('click', function () { self.lbGo(self.lbIndex + 1); });
      this.lbClose.addEventListener('click', function () { dialog.close(); });
      if (this.lbZoom) {
        this.lbZoom.addEventListener('click', function () {
          self.setZoom(!self.zoomed, 0.5, 0.5);
        });
      }

      /* A tap or click zooms 2x at that point; a sideways drag changes photo; while zoomed, the
         zoom follows the pointer. A click on the empty area around the photo closes the dialog. */
      var start = null;
      this.lbImg.addEventListener('pointerdown', function (event) {
        start = { x: event.clientX, y: event.clientY };
      });
      this.lbImg.addEventListener('pointerup', function (event) {
        if (!start) return;
        var dx = event.clientX - start.x;
        var dy = event.clientY - start.y;
        start = null;
        if (!self.zoomed && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
          self.lbGo(self.lbIndex + (dx < 0 ? 1 : -1));
          return;
        }
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
          var point = self.pointIn(event);
          self.setZoom(!self.zoomed, point.x, point.y);
        }
      });
      this.lbImg.addEventListener('pointermove', function (event) {
        if (!self.zoomed) return;
        var point = self.pointIn(event);
        self.setOrigin(point.x, point.y);
      });
      this.lbImg.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
      this.lbStage.addEventListener('click', function (event) {
        if (event.target === self.lbStage && !self.zoomed) dialog.close();
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          self.lbGo(self.lbIndex + (event.key === 'ArrowRight' ? 1 : -1));
          return;
        }
        if (event.key !== 'Tab') return;
        /* Keep Tab inside the dialog even where the browser would move on to its own chrome. */
        var items = all(dialog, 'button:not([disabled])').filter(function (button) {
          return button.getClientRects().length > 0;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && (doc.activeElement === first || !dialog.contains(doc.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (doc.activeElement === last || !dialog.contains(doc.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      });

      dialog.addEventListener('close', function () {
        self.setZoom(false);
        /* The stage follows the last photo seen, and focus returns to it (or to the opener). */
        var link = self.lbLinks[self.lbIndex];
        var slide = link ? link.closest('[data-pg-slide]') : null;
        var index = self.slides.indexOf(slide);
        if (index >= 0 && index !== self.index) self.go(index, null);
        var target = index >= 0 ? link : self.opener;
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      });
    }

    openLightbox(link) {
      var index = this.lbLinks.indexOf(link);
      this.opener = link;
      this.lbGo(index < 0 ? 0 : index);
      try {
        this.lightbox.showModal();
      } catch (error) {
        window.location.href = link.href;
        return;
      }
      this.lbClose.focus();
      track('gallery_interaction', { product_id: this.productId, action: 'lightbox', index: this.lbIndex + 1 });
    }

    lbGo(index) {
      var count = this.lbLinks.length;
      if (!count) return;
      index = (index % count + count) % count;
      this.lbIndex = index;
      this.setZoom(false);
      var link = this.lbLinks[index];
      var photo = link.querySelector('img');
      var width = parseInt(link.getAttribute('data-full-width'), 10);
      var height = parseInt(link.getAttribute('data-full-height'), 10);
      if (width && height) {
        this.lbImg.width = width;
        this.lbImg.height = height;
      }
      this.lbImg.alt = photo ? photo.alt : '';
      this.lbImg.src = link.getAttribute('data-full') || link.href;
      if (this.lbCount) this.lbCount.textContent = 'Photo ' + (index + 1) + ' of ' + count;
    }

    /* Pointer position as a fraction of the photo's own (unscaled) box. */
    pointIn(event) {
      var img = this.lbImg;
      var box = this.lbStage.getBoundingClientRect();
      var x = (event.clientX - box.left - img.offsetLeft) / (img.offsetWidth || 1);
      var y = (event.clientY - box.top - img.offsetTop) / (img.offsetHeight || 1);
      return { x: Math.max(0, Math.min(1, x)), y: Math.max(0, Math.min(1, y)) };
    }

    setOrigin(x, y) {
      this.lbImg.style.transformOrigin = (x * 100).toFixed(1) + '% ' + (y * 100).toFixed(1) + '%';
    }

    setZoom(on, x, y) {
      var zoom = !!on;
      if (!this.lbStage) return;
      var changed = zoom !== this.zoomed;
      this.zoomed = zoom;
      this.lbStage.classList.toggle('is-zoomed', zoom);
      if (this.lbZoom) this.lbZoom.setAttribute('aria-pressed', zoom ? 'true' : 'false');
      if (zoom) this.setOrigin(typeof x === 'number' ? x : 0.5, typeof y === 'number' ? y : 0.5);
      else this.lbImg.style.transformOrigin = '';
      if (zoom && changed) track('gallery_interaction', { product_id: this.productId, action: 'zoom', index: this.lbIndex + 1 });
    }
  }

  /* =====================================================================================
     <product-build>: buy box
     ===================================================================================== */
  class ProductBuild extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._observers = [];
      setupBuild(this);
    }

    disconnectedCallback() {
      (this._observers || []).forEach(function (observer) { observer.disconnect(); });
      this._observers = [];
    }
  }

  function setupBuild(root) {
    var data = readJSON(root.querySelector('[data-product-json]'));
    if (!data) return;
    var form = doc.getElementById(data.formId);
    if (!form) return;

    var moneyFormat = plainFormat(data.moneyFormat || config.moneyFormat);
    var qtyInput = form.querySelector('[data-quantity]');
    var errorBox = form.querySelector('[data-add-error]');
    var buttons = all(root, '[data-add-button]');
    var mainButton = root.querySelector('[data-add-button]:not([data-sticky-add])');
    var groups = all(root, '[data-upgrade-group]');
    var lines = root.querySelector('[data-build-lines]');
    var firstLabel = lines ? lines.querySelector('li > span') : null;
    var baseLabel = firstLabel ? firstLabel.textContent.trim() : 'Belt';
    var withUpgrades = data.mode === 'full' || data.mode === 'plating';
    var busy = false;
    var state = {
      variantId: Number(data.variantId),
      base: Number(data.basePrice) || 0,
      available: !(mainButton && mainButton.disabled)
    };

    function money(cents) {
      return formatMoney(cents, moneyFormat);
    }

    var engraving = setupEngraving(root, data, refresh);
    var gallery = root.querySelector('product-gallery');
    var legacy = data.mode === 'legacy' ? setupLegacy(root, data, money, onVariant) : null;
    if (legacy) {
      var start = legacy.current();
      state.variantId = start.id;
      state.base = start.price;
      state.available = start.available;
    }

    function quantity() {
      return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    }

    function choices() {
      return groups.map(function (group) {
        var first = group.querySelector('input[type="radio"]');
        var input = group.querySelector('input[type="radio"]:checked') || first;
        var variant = input ? input.getAttribute('data-addon-variant') : null;
        return {
          key: group.getAttribute('data-upgrade-group') || '',
          option: group.getAttribute('data-option-name') || '',
          choice: input ? input.getAttribute('data-choice') || '' : '',
          summary: input ? input.getAttribute('data-summary') || '' : '',
          variant: variant ? Number(variant) : null,
          price: variant ? parseInt(input.getAttribute('data-addon-price'), 10) || 0 : 0,
          chosen: !!(input && input !== first)
        };
      });
    }

    function compute() {
      var picks = choices();
      var engrave = engraving ? engraving.read() : null;
      var unit = state.base;
      picks.forEach(function (pick) { unit += pick.price; });
      if (engrave && engrave.on) unit += engrave.price;
      var qty = quantity();
      return { picks: picks, engrave: engrave, unit: unit, qty: qty, total: unit * qty };
    }

    /* "HD build, cast and hand-finished plates, 24K real-gold electroplating, 4 mm plates", or "Standard build".
       Included choices that differ from the default (a 3 mm plate, say) are named too, so the workshop sees them. */
    function buildText(picks) {
      var paid = picks.filter(function (pick) { return pick.variant || pick.chosen; }).map(function (pick) {
        return capitalise(pick.summary);
      });
      var included = root.querySelector('[data-upgrades-included]');
      if (included) paid.unshift(included.getAttribute('data-upgrades-included'));
      return paid.length ? paid.join(', ') : TEXT.standardBuild;
    }

    function renderLines(result) {
      if (!lines) return;
      var rows = [[baseLabel, money(state.base)]];
      result.picks.forEach(function (pick) {
        if (pick.variant) rows.push([capitalise(pick.summary), '+' + money(pick.price)]);
      });
      if (result.engrave && result.engrave.on) rows.push([TEXT.engraving, '+' + money(result.engrave.price)]);
      if (result.qty > 1) rows.push([TEXT.quantity, '× ' + result.qty]);
      clearChildren(lines);
      rows.forEach(function (row) {
        var item = doc.createElement('li');
        item.className = 'main-product__build-line';
        var label = doc.createElement('span');
        label.textContent = row[0];
        var amount = doc.createElement('span');
        amount.className = 'price';
        amount.textContent = row[1];
        item.appendChild(label);
        item.appendChild(amount);
        lines.appendChild(item);
      });
    }

    function refresh() {
      var result = compute();
      all(root, '[data-build-total]').forEach(function (element) {
        element.textContent = money(result.total);
      });
      var totalLabel = root.querySelector('[data-build-total-label]');
      if (totalLabel) totalLabel.textContent = result.qty > 1 ? 'Total for ' + result.qty + ' belts' : TEXT.total;
      groups.forEach(function (group, index) {
        var current = group.querySelector('[data-upgrade-current]');
        if (current) current.textContent = result.picks[index].choice;
      });
      result.picks.forEach(function (pick) {
        var part = root.querySelector('[data-build-part="' + pick.key + '"]');
        if (part) part.textContent = pick.summary;
      });
      renderLines(result);
      return result;
    }

    function onVariant(variant, changedIndex) {
      state.variantId = variant.id;
      state.base = variant.price;
      state.available = variant.available;
      if (gallery && variant.media && typeof gallery.showMedia === 'function') gallery.showMedia(variant.media);
      var result = refresh();
      if (typeof changedIndex === 'number') {
        track('select_build_option', {
          product_id: data.id,
          product_title: data.title,
          option_name: data.options[changedIndex],
          option_value: variant.options[changedIndex],
          variant_id: variant.id,
          price: result.unit / 100,
          currency: data.currency
        });
      }
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function (event) {
        if (!event.target || event.target.type !== 'radio') return;
        var result = refresh();
        var pick = result.picks[groups.indexOf(group)];
        track('select_build_option', {
          product_id: data.id,
          product_title: data.title,
          option_name: pick.option,
          option_value: pick.choice,
          variant_id: state.variantId,
          price: result.unit / 100,
          currency: data.currency
        });
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', refresh);
      qtyInput.addEventListener('change', refresh);
    }

    /* ---------- Add to cart ---------- */
    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message || '';
      errorBox.hidden = !message;
    }

    function setBusy(on) {
      busy = on;
      if (on) form.setAttribute('aria-busy', 'true');
      else form.removeAttribute('aria-busy');
      buttons.forEach(function (button) {
        if (on) {
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          button.textContent = TEXT.adding;
        } else {
          button.removeAttribute('aria-busy');
          button.disabled = !state.available;
          button.textContent = state.available ? (button.getAttribute('data-label') || 'Add to cart') : TEXT.notAvailable;
        }
      });
    }

    function analytics(result, items) {
      var params = {
        product_id: data.id,
        product_title: data.title,
        variant_id: state.variantId,
        quantity: result.qty,
        addons: items.length - 1,
        engraving: result.engrave && result.engrave.on ? 'yes' : 'no',
        total: result.total / 100,
        value: result.total / 100,
        currency: data.currency
      };
      var options = [];
      if (legacy) {
        var variant = legacy.current();
        (data.options || []).forEach(function (name, index) {
          options.push(name + ': ' + variant.options[index]);
        });
      } else {
        result.picks.forEach(function (pick) {
          options.push(pick.option + ': ' + pick.choice);
          params[pick.key === 'metal' ? 'plate_metal' : (pick.key === 'thickness' ? 'plate_thickness' : pick.key)] = pick.choice;
        });
      }
      params.options = options.join('; ');
      if (withUpgrades) params.build = buildText(result.picks);
      return params;
    }

    function openCart(button) {
      var cart = window.MS;
      if (!cart || typeof cart.refreshCart !== 'function' || typeof cart.openCart !== 'function') {
        window.location.href = cartUrl();
        return;
      }
      cart.refreshCart().then(function (rendered) {
        if (rendered === false) {
          window.location.href = cartUrl();
          return;
        }
        cart.openCart(button, 'product');
        if (typeof cart.announce === 'function') cart.announce(TEXT.added, doc.getElementById('cart-drawer'));
      }, function () {
        window.location.href = cartUrl();
      });
    }

    function send(items, result, button) {
      setBusy(true);
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.text().then(function (text) {
            var body = {};
            try {
              body = text ? JSON.parse(text) : {};
            } catch (error) {
              body = {};
            }
            return { ok: response.ok, body: body || {} };
          });
        })
        .then(function (outcome) {
          setBusy(false);
          if (!outcome.ok) {
            showError(outcome.body.description || outcome.body.message || TEXT.addFailed);
            return;
          }
          track('add_to_cart_build', analytics(result, items));
          try {
            openCart(button);
          } catch (error) {
            window.location.href = cartUrl();
          }
        }, function () {
          setBusy(false);
          showError(TEXT.offline);
        });
    }

    /* Listens on the form, so it runs before ms.js (document level) and takes over the submit.
       Add-on listings keep the plain ms.js add (one line, no group). */
    form.addEventListener('submit', function (event) {
      if (data.mode === 'addon' || typeof window.fetch !== 'function') return;
      event.preventDefault();
      if (busy || !state.available) return;

      var result = compute();
      if (result.engrave && result.engrave.on && !result.engrave.name) {
        engraving.fail(TEXT.engraveMissing);
        return;
      }
      showError('');

      var group = groupId();
      var items = [];
      result.picks.forEach(function (pick) {
        if (!pick.variant) return;
        items.push({ id: pick.variant, quantity: result.qty, properties: { 'For belt': data.title, _ms_group: group } });
      });
      if (result.engrave && result.engrave.on) {
        var addonProps = { 'For belt': data.title, Engraving: result.engrave.name };
        if (result.engrave.line2) addonProps['Engraving, second line'] = result.engrave.line2;
        addonProps._ms_group = group;
        items.push({ id: result.engrave.variant, quantity: result.qty, properties: addonProps });
      }
      var beltProps = {};
      if (withUpgrades) beltProps.Build = buildText(result.picks);
      if (result.engrave && result.engrave.on) {
        beltProps.Engraving = result.engrave.name;
        if (result.engrave.line2) beltProps['Engraving, second line'] = result.engrave.line2;
      }
      beltProps._ms_group = group;
      /* Add-ons first and the belt last: the cart lists the last line added first. */
      items.push({ id: Number(state.variantId), quantity: result.qty, properties: beltProps });

      send(items, result, event.submitter || mainButton);
    });

    /* Back/forward cache: never come back to a page stuck on "Adding…". */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted && busy) setBusy(false);
    });

    setupSticky(root, data, function () { return state.variantId; });
    refresh();
  }

  /* ---------- Name plate engraving (snippets/product-engraving.liquid) ---------- */
  function setupEngraving(root, data, onChange) {
    var box = root.querySelector('[data-engrave]');
    if (!box) return null;
    var toggle = box.querySelector('[data-engrave-toggle]');
    var fields = box.querySelector('[data-engrave-fields]');
    var nameInput = box.querySelector('[data-engrave-name]');
    var line2Input = box.querySelector('[data-engrave-line2]');
    var errorEl = box.querySelector('[data-engrave-error]');
    var variant = Number(box.getAttribute('data-engrave-variant'));
    var price = parseInt(box.getAttribute('data-engrave-price'), 10) || 0;
    if (!toggle || !fields || !nameInput || !variant) return null;

    function fail(message) {
      if (errorEl) {
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
      }
      if (message) {
        nameInput.setAttribute('aria-invalid', 'true');
        nameInput.focus();
      } else {
        nameInput.removeAttribute('aria-invalid');
      }
    }

    function sync() {
      fields.hidden = !toggle.checked;
    }

    toggle.addEventListener('change', function () {
      sync();
      fail('');
      if (toggle.checked) nameInput.focus();
      onChange();
      track('select_build_option', {
        product_id: data.id,
        product_title: data.title,
        option_name: 'Engraving',
        option_value: toggle.checked ? 'Added' : 'Removed',
        currency: data.currency
      });
    });
    nameInput.addEventListener('input', function () {
      if (nameInput.value.trim()) fail('');
    });
    /* A box restored as ticked (back/forward) shows its fields. */
    sync();

    return {
      fail: fail,
      read: function () {
        return {
          on: toggle.checked,
          name: nameInput.value.trim(),
          line2: line2Input ? line2Input.value.trim() : '',
          variant: variant,
          price: price
        };
      }
    };
  }

  /* ---------- Listings that still have options (snippets/product-variant-picker.liquid) ---------- */
  function setupLegacy(root, data, money, onVariant) {
    var forms = all(root, '[data-option-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var variants = data.variants || [];
    if (!idInput || !variants.length) return null;

    function byId(id) {
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function byOptions(options) {
      for (var i = 0; i < variants.length; i += 1) {
        var same = true;
        for (var j = 0; j < options.length; j += 1) {
          if (variants[i].options[j] !== options[j]) {
            same = false;
            break;
          }
        }
        if (same) return variants[i];
      }
      return null;
    }

    /* When the exact combination does not exist, keep the choice just made and stay close on the rest. */
    function nearest(options, index) {
      var best = null;
      var bestScore = -1;
      variants.forEach(function (variant) {
        if (variant.options[index] !== options[index]) return;
        var score = variant.available ? 0.5 : 0;
        variant.options.forEach(function (value, position) {
          if (value === options[position]) score += 1;
        });
        if (score > bestScore) {
          bestScore = score;
          best = variant;
        }
      });
      return best;
    }

    function chosen() {
      return forms.map(function (form) {
        var input = form.querySelector('input[type="radio"]:checked');
        return input ? input.getAttribute('data-value') : null;
      });
    }

    var current = byId(idInput.value) || variants[0];

    function differenceText(target, selected) {
      if (selected) return TEXT.selected;
      if (!target) return TEXT.notOffered;
      if (!target.available) return TEXT.notAvailable;
      var difference = target.price - current.price;
      if (!difference) return TEXT.samePrice;
      return (difference > 0 ? '+' : '−') + money(Math.abs(difference)).replace(/\.00(?=\D*$)/, '');
    }

    /* Matches snippets/price.liquid: [data-price], plus "Price now" and an <s data-compare-price> on sale. */
    function setPrice(amount, variant) {
      amount.textContent = money(variant.price);
      var line = amount.parentNode;
      if (!line) return;
      var label = amount.previousElementSibling;
      var hasLabel = !!(label && label.classList.contains('visually-hidden'));
      var compare = line.querySelector('[data-compare-price]');
      if (!variant.compareText) {
        if (hasLabel) line.removeChild(label);
        if (compare) line.removeChild(compare);
        return;
      }
      if (!hasLabel) {
        label = doc.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = 'Price now ';
        line.insertBefore(label, amount);
      }
      if (!compare) {
        compare = doc.createElement('s');
        compare.className = 'muted';
        compare.setAttribute('data-compare-price', '');
        line.appendChild(doc.createTextNode(' '));
        line.appendChild(compare);
      }
      clearChildren(compare);
      var before = doc.createElement('span');
      before.className = 'visually-hidden';
      before.textContent = 'Price before ';
      compare.appendChild(before);
      compare.appendChild(doc.createTextNode(plainFormat(variant.compareText)));
    }

    function apply(variant, changedIndex) {
      current = variant;
      forms.forEach(function (form, index) {
        var legend = form.querySelector('[data-option-current]');
        if (legend) legend.textContent = variant.options[index];
        all(form, 'input[type="radio"]').forEach(function (input) {
          var value = input.getAttribute('data-value');
          var options = variant.options.slice();
          options[index] = value;
          var target = byOptions(options);
          var selected = value === variant.options[index];
          input.checked = selected;
          input.value = target ? target.id : '';
          input.disabled = !target || (!target.available && !selected);
          var difference = input.parentNode.querySelector('[data-option-diff]');
          if (difference) difference.textContent = differenceText(target, selected);
        });
      });

      idInput.value = variant.id;
      /* Lets Shopify components that watch the form (instalment terms) follow the change. */
      try {
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (error) {
        /* Nothing else depends on this event. */
      }
      all(root, '[data-price]').forEach(function (amount) {
        setPrice(amount, variant);
      });
      all(root, '[data-build-value]').forEach(function (cell) {
        cell.textContent = variant.options[parseInt(cell.getAttribute('data-build-value'), 10)] || '';
      });
      all(root, '[data-add-button]').forEach(function (button) {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.disabled = !variant.available;
        button.textContent = variant.available ? (button.getAttribute('data-label') || 'Add to cart') : TEXT.notAvailable;
      });

      if (window.history && typeof window.history.replaceState === 'function') {
        try {
          var address = new URL(window.location.href);
          address.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', address.toString());
        } catch (error) {
          /* The address bar is a convenience only. */
        }
      }

      try {
        root.dispatchEvent(new CustomEvent('ms:variant-change', {
          bubbles: true,
          detail: { productId: data.id, variant: variant }
        }));
      } catch (error) {
        /* No listener depends on this event. */
      }

      onVariant(variant, changedIndex);
    }

    forms.forEach(function (form, index) {
      form.addEventListener('change', function (event) {
        if (!event.target || event.target.type !== 'radio') return;
        var options = chosen();
        var variant = byOptions(options) || nearest(options, index);
        if (variant) apply(variant, index);
      });
      /* The submit button exists only without JavaScript; Enter inside a group must not reload. */
      form.addEventListener('submit', function (event) {
        event.preventDefault();
      });
    });

    /* A browser may restore earlier radio choices on reload or back: bring the page in line. */
    var restored = forms.length ? byOptions(chosen()) : null;
    if (restored && restored !== current) apply(restored);

    return {
      current: function () { return current; }
    };
  }

  /* ---------- Sticky add-to-cart bar ----------
     Shown once both the title and the main button are out of view (scrolled past, or the button not
     reached yet on a phone), hidden again at the footer. It carries the live total. */
  function setupSticky(root, data, variantId) {
    var bar = root.querySelector('[data-sticky]');
    var main = root.querySelector('[data-add-button]:not([data-sticky-add])');
    var title = root.querySelector('[data-product-title]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;

    var mainVisible = true;
    var titleVisible = !!title;
    var atFooter = false;

    function update() {
      var show = !mainVisible && !titleVisible && !atFooter;
      if (show === !bar.hidden) return;
      bar.hidden = !show;
      /* Keeps keyboard focus from landing underneath the bar. */
      var height = show ? bar.offsetHeight : 0;
      doc.documentElement.style.scrollPaddingBottom = height ? (height + 16) + 'px' : '';
    }

    function watch(element, callback) {
      var observer = new IntersectionObserver(function (entries) {
        callback(entries[entries.length - 1].isIntersecting);
        update();
      });
      observer.observe(element);
      if (root._observers) root._observers.push(observer);
    }

    watch(main, function (visible) { mainVisible = visible; });
    if (title) watch(title, function (visible) { titleVisible = visible; });
    var footer = doc.querySelector('.site-footer');
    if (footer) watch(footer, function (visible) { atFooter = visible; });

    bar.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-sticky-add]') : null;
      if (!button || button.disabled) return;
      track('sticky_atc_click', { product_id: data.id, variant_id: variantId() });
    });
  }

  /* =====================================================================================
     Recommendations: fetched from the Product Recommendations API as rendered section HTML
     ===================================================================================== */
  function initRecommendations(placeholder) {
    if (placeholder.getAttribute('data-ready')) return;
    placeholder.setAttribute('data-ready', 'true');
    var url = placeholder.getAttribute('data-url');
    if (!url || !window.fetch || !window.DOMParser) return;

    function load() {
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          if (!html || !placeholder.parentNode) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-recommendations-list]');
          if (fresh) placeholder.parentNode.replaceChild(doc.importNode(fresh, true), placeholder);
        })
        .catch(function () {
          /* Without recommendations the page is simply shorter. */
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) {
            observer.disconnect();
            load();
            return;
          }
        }
      }, { rootMargin: '0px 0px 600px 0px' });
      observer.observe(placeholder);
    } else {
      load();
    }
  }

  function bootRecommendations(scope) {
    all(scope, '[data-product-recommendations]').forEach(initRecommendations);
  }

  if (!window.customElements.get('product-gallery')) window.customElements.define('product-gallery', ProductGallery);
  if (!window.customElements.get('product-build')) window.customElements.define('product-build', ProductBuild);

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { bootRecommendations(doc); });
  } else {
    bootRecommendations(doc);
  }

  /* Theme editor: sections are re-rendered in place (custom elements set themselves up). */
  doc.addEventListener('shopify:section:load', function (event) {
    bootRecommendations(event.target);
  });
})();
